export const lastSatisfactionMap = {
  0: "🚫",
  1: "🙂",
  2: "😐",
  3: "☹️",
};

export const ROLE_ADMIN = {
  role: "ROLE_ADMIN",
  users: {
    view: true,
    invite: true,
    edit: true,
  },
};

export const HOW_TO_LINK =
  "https://how.revoo-app.com/knowledge/come-funziona-il-codice-referral-su-revoo";

export const UNREGISTER_LINK =
  "https://www.revoo-app.com/richiesta-eliminazione-account-revoo/";

export const CONTACT_LINK =
  "https://share-eu1.hsforms.com/1JjywJqqARzKGJ8iRcO0xLQfzp6j";

export const GDPR_LINK = "https://revoo-app.com/privacy";

export const TERMS_LINK = "https://revoo-app.com/terms";
